import { useWishlistProductIds } from '@aboutyou/legacy-shared'
import { RecoSectionContent } from '@aboutyou/legacy-tracking-sdk'
import SearchBar from 'components/SearchBar'
import { useTranslation } from 'helpers/hooks/useTranslation'
import { unescapeAndDecode } from 'helpers/text'
import React, { FC } from 'react'
import WishlistProductReco from 'sharedComponents/ProductRecoSliders/WishlistProductReco'
import { useSearchPageStore } from 'store/context'
import styled from 'styled-components'
import {
  backgroundColor,
  complementaryColor,
  logoColor,
} from 'uiComponents/constants/colors'
import { fsS, fsXS } from 'uiComponents/constants/typography'

const Container = styled.div`
  height: 248px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(
    to bottom,
    ${backgroundColor},
    ${complementaryColor}
  );
  margin: 0 0 30px;
  border-bottom: 1px solid #e6e6e7;
`

const Headline = styled.div`
  font-size: ${fsS};
  color: ${logoColor};
  line-height: 1.5;
`

const Subline = styled.div`
  font-size: ${fsXS};
  color: ${logoColor};
  line-height: 1.5;
  margin: 10px 0 40px 10px;
`

const RecoContainer = styled.div`
  margin: 30px 0;
`

const SearchBarContainer = styled.div`
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
`

const EmptyResult: FC = () => {
  const [t] = useTranslation()
  const searchPageStore = useSearchPageStore()
  const wishlistProductIds = useWishlistProductIds()
  const showWishlistProducts = wishlistProductIds.length > 0

  const renderRecos = () => (
    <>
      {showWishlistProducts && (
        <RecoContainer>
          <WishlistProductReco
            recoType={RecoSectionContent.wishlistProducts}
            productIds={wishlistProductIds}
          />
        </RecoContainer>
      )}
    </>
  )

  return (
    <>
      <Container>
        <div>
          <Headline data-testid="EmptyResultHeadline">
            {t('Deine Suche nach "{{- term}}" ergab leider keinen Treffer.', {
              term: unescapeAndDecode(
                searchPageStore.filter.selectedFilters.term
                  ? searchPageStore.filter.selectedFilters.term[0]
                  : '',
              ),
            })}
          </Headline>
          <Subline data-testid="EmptyResultSubline">
            {t('Versuch es doch noch einmal mit einem anderen Begriff')}
          </Subline>
          <SearchBarContainer data-testid="SearchBarContainer">
            <SearchBar />
          </SearchBarContainer>
        </div>
      </Container>
      {searchPageStore.multiSearches.length === 0 && renderRecos()}
    </>
  )
}

export default EmptyResult
